module.exports = __webpack_public_path__ + "img/camera.8faeccc2.png";